import * as React from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';

export default function SearchBox({label, handleFilter, isLoading}) {

  return (
    <Paper
      component='form'
      sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', minWidth: '95%', maxWidth: 300, width: '30%', boxShadow: 0.5 }}
    >
      <InputBase
          type={'search'}
          id='search'
          label={label}
          sx={{ ml: 1, flex: 1 }}
          placeholder={label}
          inputProps={{ 'aria-label': label }}
          onChange={handleFilter}
          disabled={isLoading}
          fullWidth
      />
      <SearchIcon sx={{color: 'primary.text'}}/>
    </Paper>
  );
}
